import { gql } from '__generated__';

export default gql(`
  query GetRevenueReport($project: ID!, $events: [ID!], $start_date: String, $end_date: String) {
    project(id: $project) {
      id
      revenue_stats(events: $events, start_date: $start_date, end_date: $end_date) {
        paid_amount
        refunded_amount
      }
    }
  }
`);
